import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { view as view_2, update as update_1, init as init_1, Model_$reflection as Model_$reflection_1, Msg_$reflection as Msg_$reflection_1 } from "./MainReg.fs.js";
import { view as view_1, update as update_2, init as init_2, Model_$reflection as Model_$reflection_2, Msg_$reflection as Msg_$reflection_2 } from "./MainProd.fs.js";
import { string_type, record_type, union_type, class_type, unit_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { RESP$1_$reflection } from "../shared/Shared.fs.js";
import { Cmd_map } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Infra_getPreferableLangugage, apiCmd, Infra_clearUserAndSettingsAndRedirect, noCmd } from "./Common.fs.js";
import { singleton, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import * as react from "react";
import { termsOfUse } from "./MainTemplates.fs.js";
import { regL10n } from "./L10n.fs.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Reg", "Prod", "AcceptTermsOfUse", "CancelTermsOfUse", "BecomeProducerResp", "Exn"];
    }
}

export function Msg_$reflection() {
    return union_type("Main.Msg", [], Msg, () => [[["Item", Msg_$reflection_1()]], [["Item", Msg_$reflection_2()]], [], [], [["Item", RESP$1_$reflection(unit_type)]], [["Item", class_type("System.Exception")]]]);
}

export class Model extends Record {
    constructor(Area) {
        super();
        this.Area = Area;
    }
}

export function Model_$reflection() {
    return record_type("Main.Model", [], Model, () => [["Area", Area_$reflection()]]);
}

export class Area extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Public", "Prod", "TermOfUse"];
    }
}

export function Area_$reflection() {
    return union_type("Main.Area", [], Area, () => [[["Item", Model_$reflection_1()]], [["Item", Model_$reflection_2()]], [["error", string_type]]]);
}

export function init(api, user) {
    let patternInput_2;
    if (user.IsPrivate) {
        const patternInput = init_1(api, user);
        patternInput_2 = [new Area(0, [patternInput[0]]), Cmd_map((Item) => (new Msg(0, [Item])), patternInput[1])];
    }
    else if (user.IsProducer) {
        const patternInput_1 = init_2(api, user);
        patternInput_2 = [new Area(1, [patternInput_1[0]]), Cmd_map((Item_1) => (new Msg(1, [Item_1])), patternInput_1[1])];
    }
    else {
        patternInput_2 = noCmd(new Area(2, [""]));
    }
    return [new Model(patternInput_2[0]), patternInput_2[1]];
}

export function update(api, user, msg, cm) {
    const matchValue = cm.Area;
    let matchResult, txt, ex, subModel_1, subMsg, subModel_3, subMsg_1;
    switch (msg.tag) {
        case 2: {
            if (matchValue.tag === 2) {
                matchResult = 1;
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 4: {
            if (msg.fields[0].Value.tag === 1) {
                if (matchValue.tag === 2) {
                    matchResult = 3;
                    txt = msg.fields[0].Value.fields[0];
                }
                else {
                    matchResult = 7;
                }
            }
            else if (matchValue.tag === 2) {
                matchResult = 2;
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 5: {
            if (matchValue.tag === 2) {
                matchResult = 4;
                ex = msg.fields[0];
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 0: {
            if (matchValue.tag === 0) {
                matchResult = 5;
                subModel_1 = matchValue.fields[0];
                subMsg = msg.fields[0];
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 1: {
            if (matchValue.tag === 1) {
                matchResult = 6;
                subModel_3 = matchValue.fields[0];
                subMsg_1 = msg.fields[0];
            }
            else {
                matchResult = 7;
            }
            break;
        }
        default:
            if (matchValue.tag === 2) {
                matchResult = 0;
            }
            else {
                matchResult = 7;
            }
    }
    switch (matchResult) {
        case 0: {
            Infra_clearUserAndSettingsAndRedirect("/");
            return noCmd(cm);
        }
        case 1:
            return apiCmd(api.becomeProducer, void 0, (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(5, [Item_1])), cm);
        case 2: {
            const patternInput = init_2(api, user);
            return [new Model(new Area(1, [patternInput[0]])), Cmd_map((Item_2) => (new Msg(1, [Item_2])), patternInput[1])];
        }
        case 3:
            return noCmd(new Model(new Area(2, [txt])));
        case 4:
            return noCmd(new Model(new Area(2, [ex.message])));
        case 5: {
            const patternInput_1 = update_1(api, user, subMsg, subModel_1);
            return [new Model(new Area(0, [patternInput_1[0]])), Cmd_map((Item_3) => (new Msg(0, [Item_3])), patternInput_1[1])];
        }
        case 6: {
            const patternInput_2 = update_2(api, user, subMsg_1, subModel_3);
            return [new Model(new Area(1, [patternInput_2[0]])), Cmd_map((Item_4) => (new Msg(1, [Item_4])), patternInput_2[1])];
        }
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, settings, model) {
    const matchValue = model.Area;
    switch (matchValue.tag) {
        case 1:
            return view_1((arg_1) => {
                dispatch(new Msg(1, [arg_1]));
            }, user, settings, matchValue.fields[0]);
        case 2: {
            const txt = matchValue.fields[0];
            const children_2 = toList(delay(() => ((txt !== "") ? singleton(react.createElement("h1", {
                className: "title is-1 has-text-centered has-text-danger",
            }, txt)) : singleton(termsOfUse(dispatch, new Msg(2, []), new Msg(3, []))))));
            return react.createElement("div", {}, ...children_2);
        }
        default:
            return view_2((arg) => {
                dispatch(new Msg(0, [arg]));
            }, user, settings, matchValue.fields[0], regL10n(Infra_getPreferableLangugage()));
    }
}

